export default {"src":"/_next/static/media/carDamage_24.27d7eeda.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};